<template>
  <article class="priceDetail" :opened="opened">
    <section class="priceDetail__list">
      <PriceDetailItem
        v-if="opened && outboundPrice"
        :price="outboundPrice"
        :currency="fullPrice.currency"
        headerLabel="shopping_lib.outbound_flight"
      />
      <PriceDetailItem
        v-if="opened && outboundPrice"
        :price="returnPrice"
        :currency="fullPrice.currency"
        headerLabel="shopping_lib.return_flight"
      />
      <PriceDetailItem
        :price="fullPrice.amount"
        :currency="fullPrice.currency"
        headerLabel="total_to_pay"
      >
        <i
          v-if="showOpenDetail"
          @click="opened = !opened"
          class="priceDetail__itemIcon fas fa-angle-down"
        ></i>
      </PriceDetailItem>
    </section>
  </article>
</template>
<script>
import PriceDetailItem from './PriceDetailItem.vue'
import { get } from 'lodash'
export default {
  name: 'PriceDetail',
  components: { PriceDetailItem },
  props: {
    journeys: {
      required: true,
      type: Object,
    },
  },
  data: function () {
    return {
      opened: false,
    }
  },
  computed: {
    fullPrice: function () {
      let amount = 0
      let currency = ''

      for (const key in this.journeys) {
        const journey = this.journeys[key]
        const fareInformation = journey?.fare?.fare_information
        const segmentPrice = fareInformation?.segment_price || 0
        currency = fareInformation?.currency_reference_id
        amount += segmentPrice
      }

      return { amount, currency }
    },
    outboundPrice: function () {
      return get(this.journeys, '[1].fare.fare_information.segment_price', null)
    },
    returnPrice: function () {
      return get(this.journeys, '[2].fare.fare_information.segment_price', null)
    },
    showOpenDetail: function () {
      return Object.keys(this.journeys).length >= 2
    },
  },
}
</script>
<style lang="sass">
.priceDetail
  width: 100%
  display: grid
  gap: .25rem
  background: var(--color-success)
  color: var(--color-onSuccess)
  border-radius: .5rem
  &__list
    flex-direction: column

.priceDetail__item
  position: relative
  display: flex
  flex-direction: column
  padding: .5rem .75rem
  &Header
    font-size: var(--font-size-xs)
  &Main
    display: flex
    gap: .25rem
    align-items: baseline
    font-weight: bold
    &--amount
      font-size: var(--font-size-md)
      line-height: 2.1875rem
  i.priceDetail__itemIcon
    position: absolute
    right: 0
    top: 0
    height: 100%
    display: flex
    align-items: center
    padding: 0 .75rem

.priceDetail[opened]
  background: var(--color-background)
  border: 1px solid var(--color-success)
  color: var(--color-primary)
  .priceDetail__list
    .priceDetail__item:last-child
      background: rgba(24, 99, 41, 0.10)
    .priceDetail__item:not(:last-child)
      border-bottom: 1px solid var(--color-overlay-20)
      .priceDetail__itemMain,
      .priceDetail__itemMain--amount
        font-size: var(--font-size-base)
        line-height: 1.5rem
.priceDetail:not([opened])
  .priceDetail__itemIcon
    transform: rotate(180deg)
</style>
